import { template as template_6dc3598401a94fc4a7781339791a4010 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { fn, hash } from '@ember/helper';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { t } from 'ember-intl';
import { waitFor } from '@ember/test-waiters';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import FileInput from 'eflex/components/file-input';
import TaskStatuses from 'eflex/constants/task-statuses';
import config from 'eflex/config/environment';
import TrashCan from 'eflex/components/trash-can';
import { and, or, not } from 'ember-truth-helpers';
import { ALLOWED_UPLOAD_EXTENSIONS, MAX_UPLOAD_SIZE } from 'eflex/constants/file-types';
const JemUploadFileDetails = template_6dc3598401a94fc4a7781339791a4010(`
{{#if @childStatus.uploadedData}}
  {{@childStatus.uploadedData.fileName}}
{{else if @uploadedFile}}
  <div class="d-flex align-items-center">
    <div class="file-name text-gray-800">{{@uploadedFile.name}}</div>
    <TrashCan class="ms-2" @onDelete={{@clearFile}}/>
  </div>
{{else if @childStatus.isRunning}}
  <FileInput class="upload-file py-2" @onChange={{@onChange}}>
    <div class="btn btn-primary">
      <FaIcon @icon="upload" @prefix="fas" class="me-2" />
      {{t "plant.task.taskTypes.uploadFile"}}
    </div>
  </FileInput>
{{/if}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default class JemUploadFile extends Component {
    @service
    fileUploader;
    @service
    notifier;
    @service
    store;
    @tracked
    uploadedFile = null;
    onTaskComplete = task({
        drop: true
    }, waitFor(async (status)=>{
        if (status > TaskStatuses.STOPPED && this.uploadedFile != null) {
            let result;
            try {
                result = await this.fileUploader.post.perform('uploadedFiles', this.uploadedFile, {
                    taskId: this.args.task.id,
                    serialNumber: this.args.childStatus.parent.serialNumber
                });
            } catch  {
                this.notifier.sendError('fileUploadError');
            }
            this.args.childStatus.uploadedData = this.store.createRecord('uploaded-file-datum', {
                fileUrl: `${config.servicePrefix}/uploadedFiles/${result.uploadedFile.id}.${result.uploadedFile.fileName}`,
                fileName: result.uploadedFile.fileName,
                expiresAt: new Date(result.uploadedFile.expiresAt)
            });
        }
        this.uploadedFile = null;
        return this.args.onTaskComplete(status);
    }));
    onSelectedFile = (files)=>{
        if (files == null || files[0] == null) {
            return;
        }
        const selectedFile = files[0];
        const normalizeFile = (file)=>{
            const ext = file.name.split('.').pop().toLowerCase();
            if (ext === 'ini' && (!file.type || file.type === '')) {
                return new File([
                    file
                ], file.name, {
                    type: 'text/plain',
                    lastModified: file.lastModified
                });
            }
            return file;
        };
        const file = normalizeFile(selectedFile);
        const isAllowedType = Object.values(ALLOWED_UPLOAD_EXTENSIONS).some((value)=>{
            if (Array.isArray(value)) {
                return value.includes(file.type);
            }
            return value === file.type;
        });
        if (!isAllowedType) {
            this.notifier.sendError('fileTypeNotSupported');
            return;
        }
        if (file.size > MAX_UPLOAD_SIZE) {
            this.notifier.sendError('fileUploadTooLarge');
            return;
        }
        this.uploadedFile = new File(files, files[0].name, {
            type: files[0].type
        });
    };
    static{
        template_6dc3598401a94fc4a7781339791a4010(`
  {{yield
    (hash
      taskDetails=(component
        JemUploadFileDetails
        disabled=@disabled
        notAuthorized=@notAuthorized
        isAuto=@task.isAuto
        childStatus=@childStatus
        taskConfig=@taskConfig
        onChange=this.onSelectedFile
        uploadedFile=this.uploadedFile
        clearFile=(fn (mut this.uploadedFile) null)
      )
      okDisabled=(or
        this.onTaskComplete.isRunning
        (and (not this.uploadedFile) @childStatus.isStarted)
      )
      onTaskComplete=this.onTaskComplete.perform
    )
  }}
`, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
